/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AIModel,
  AITool,
  AWSCredentials,
  AssistantConversation,
  AssistantMessage,
  ErrorResponse,
  Prompt,
  PromptLog,
  PromptRequest,
  SavedAIConversation,
  SavedPromptRequest,
  StringResource,
} from '../models';
import {
    AIModelFromJSON,
    AIModelToJSON,
    AIToolFromJSON,
    AIToolToJSON,
    AWSCredentialsFromJSON,
    AWSCredentialsToJSON,
    AssistantConversationFromJSON,
    AssistantConversationToJSON,
    AssistantMessageFromJSON,
    AssistantMessageToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PromptFromJSON,
    PromptToJSON,
    PromptLogFromJSON,
    PromptLogToJSON,
    PromptRequestFromJSON,
    PromptRequestToJSON,
    SavedAIConversationFromJSON,
    SavedAIConversationToJSON,
    SavedPromptRequestFromJSON,
    SavedPromptRequestToJSON,
    StringResourceFromJSON,
    StringResourceToJSON,
} from '../models';

export interface AddPromptRequest {
    prompt: Prompt;
}

export interface ChatAssistantRequest {
    assistantConversation: AssistantConversation;
    streamingKey?: string;
}

export interface ChatSavedPromptRequest {
    name: string;
    savedPromptRequest: SavedPromptRequest;
    streamingKey?: string;
}

export interface GetPromptLogsRequest {
    id: string;
}

export interface Prompt2Request {
    promptRequest: PromptRequest;
    streamingKey?: string;
}

export interface RemoveAssistantConversationRequest {
    id: string;
}

export interface RunSavedPromptRequest {
    name: string;
    savedPromptRequest: SavedPromptRequest;
    streamingKey?: string;
}

export interface SaveAssistantConversationRequest {
    savedAIConversation: SavedAIConversation;
}

export interface SpeechToTextRequest {
    file: Blob;
    model?: SpeechToTextModelEnum;
    prompt?: string;
}

/**
 * 
 */
export class AIApi extends runtime.BaseAPI {

    /**
     * Adds or edits a prompt (Roles: admin)
     */
    async addPromptRaw(requestParameters: AddPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Prompt>> {
        if (requestParameters.prompt === null || requestParameters.prompt === undefined) {
            throw new runtime.RequiredError('Prompt','Required parameter requestParameters.prompt was null or undefined when calling addPrompt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/prompts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PromptToJSON(requestParameters.prompt),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PromptFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addPromptRequestOptionsRaw(requestParameters: AddPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.prompt === null || requestParameters.prompt === undefined) {
            throw new runtime.RequiredError('Prompt','Required parameter requestParameters.prompt was null or undefined when calling addPrompt.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/prompts`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PromptToJSON(requestParameters.prompt),
        };
        return responseConfig
    }

    /**
     * Adds or edits a prompt (Roles: admin)
     */
    async addPrompt(requestParameters: AddPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Prompt> {
        const response = await this.addPromptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Chats with an assistant (Roles: admin, physician)
     */
    async chatAssistantRaw(requestParameters: ChatAssistantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssistantMessage>> {
        if (requestParameters.assistantConversation === null || requestParameters.assistantConversation === undefined) {
            throw new runtime.RequiredError('AssistantConversation','Required parameter requestParameters.assistantConversation was null or undefined when calling chatAssistant.');
        }

        const queryParameters: any = {};

        if (requestParameters.streamingKey !== undefined) {
            queryParameters['streamingKey'] = requestParameters.streamingKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/assistant/chat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssistantConversationToJSON(requestParameters.assistantConversation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssistantMessageFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    chatAssistantRequestOptionsRaw(requestParameters: ChatAssistantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.assistantConversation === null || requestParameters.assistantConversation === undefined) {
            throw new runtime.RequiredError('AssistantConversation','Required parameter requestParameters.assistantConversation was null or undefined when calling chatAssistant.');
        }

        const queryParameters: any = {};

        if (requestParameters.streamingKey !== undefined) {
            queryParameters['streamingKey'] = requestParameters.streamingKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/assistant/chat`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: AssistantConversationToJSON(requestParameters.assistantConversation),
        };
        return responseConfig
    }

    /**
     * Chats with an assistant (Roles: admin, physician)
     */
    async chatAssistant(requestParameters: ChatAssistantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssistantMessage> {
        const response = await this.chatAssistantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Chats with a saved prompt (Roles: admin, physician)
     */
    async chatSavedPromptRaw(requestParameters: ChatSavedPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssistantMessage>>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling chatSavedPrompt.');
        }

        if (requestParameters.savedPromptRequest === null || requestParameters.savedPromptRequest === undefined) {
            throw new runtime.RequiredError('SavedPromptRequest','Required parameter requestParameters.savedPromptRequest was null or undefined when calling chatSavedPrompt.');
        }

        const queryParameters: any = {};

        if (requestParameters.streamingKey !== undefined) {
            queryParameters['streamingKey'] = requestParameters.streamingKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/prompt/{name}/chat`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SavedPromptRequestToJSON(requestParameters.savedPromptRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssistantMessageFromJSON));
    }

    /**
        Request Config Getter
     */
    chatSavedPromptRequestOptionsRaw(requestParameters: ChatSavedPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling chatSavedPrompt.');
        }

        if (requestParameters.savedPromptRequest === null || requestParameters.savedPromptRequest === undefined) {
            throw new runtime.RequiredError('SavedPromptRequest','Required parameter requestParameters.savedPromptRequest was null or undefined when calling chatSavedPrompt.');
        }

        const queryParameters: any = {};

        if (requestParameters.streamingKey !== undefined) {
            queryParameters['streamingKey'] = requestParameters.streamingKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/prompt/{name}/chat`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: SavedPromptRequestToJSON(requestParameters.savedPromptRequest),
        };
        return responseConfig
    }

    /**
     * Chats with a saved prompt (Roles: admin, physician)
     */
    async chatSavedPrompt(requestParameters: ChatSavedPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssistantMessage>> {
        const response = await this.chatSavedPromptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * gives AWS Transcribe credentials (Roles: admin, physician)
     */
    async getAWSTranscribeCredentialsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AWSCredentials>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/awsTranscribeCredentials`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AWSCredentialsFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    getAWSTranscribeCredentialsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/awsTranscribeCredentials`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * gives AWS Transcribe credentials (Roles: admin, physician)
     */
    async getAWSTranscribeCredentials(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AWSCredentials> {
        const response = await this.getAWSTranscribeCredentialsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets saved conversations (Roles: admin, physician)
     */
    async getAssistantConversationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SavedAIConversation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/conversations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SavedAIConversationFromJSON));
    }

    /**
        Request Config Getter
     */
    getAssistantConversationsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/conversations`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets saved conversations (Roles: admin, physician)
     */
    async getAssistantConversations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SavedAIConversation>> {
        const response = await this.getAssistantConversationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all models (Roles: admin)
     */
    async getModelsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AIModel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/models`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AIModelFromJSON));
    }

    /**
        Request Config Getter
     */
    getModelsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/models`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all models (Roles: admin)
     */
    async getModels(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AIModel>> {
        const response = await this.getModelsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all recent prompt logs (Roles: admin, physician)
     */
    async getPromptLogsRaw(requestParameters: GetPromptLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PromptLog>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPromptLogs.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/prompt/logs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PromptLogFromJSON));
    }

    /**
        Request Config Getter
     */
    getPromptLogsRequestOptionsRaw(requestParameters: GetPromptLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPromptLogs.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/prompt/logs/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all recent prompt logs (Roles: admin, physician)
     */
    async getPromptLogs(requestParameters: GetPromptLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PromptLog>> {
        const response = await this.getPromptLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all prompts (Roles: admin)
     */
    async getPromptsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Prompt>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/prompts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PromptFromJSON));
    }

    /**
        Request Config Getter
     */
    getPromptsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/prompts`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all prompts (Roles: admin)
     */
    async getPrompts(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Prompt>> {
        const response = await this.getPromptsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Gets all tools (Roles: admin)
     */
    async getToolsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AITool>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/tools`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AIToolFromJSON));
    }

    /**
        Request Config Getter
     */
    getToolsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/tools`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all tools (Roles: admin)
     */
    async getTools(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AITool>> {
        const response = await this.getToolsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Executes a prompt (Roles: admin, physician)
     */
    async prompt2Raw(requestParameters: Prompt2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringResource>> {
        if (requestParameters.promptRequest === null || requestParameters.promptRequest === undefined) {
            throw new runtime.RequiredError('PromptRequest','Required parameter requestParameters.promptRequest was null or undefined when calling prompt2.');
        }

        const queryParameters: any = {};

        if (requestParameters.streamingKey !== undefined) {
            queryParameters['streamingKey'] = requestParameters.streamingKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/prompt2`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PromptRequestToJSON(requestParameters.promptRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    prompt2RequestOptionsRaw(requestParameters: Prompt2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.promptRequest === null || requestParameters.promptRequest === undefined) {
            throw new runtime.RequiredError('PromptRequest','Required parameter requestParameters.promptRequest was null or undefined when calling prompt2.');
        }

        const queryParameters: any = {};

        if (requestParameters.streamingKey !== undefined) {
            queryParameters['streamingKey'] = requestParameters.streamingKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/prompt2`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: PromptRequestToJSON(requestParameters.promptRequest),
        };
        return responseConfig
    }

    /**
     * Executes a prompt (Roles: admin, physician)
     */
    async prompt2(requestParameters: Prompt2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringResource> {
        const response = await this.prompt2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes saved conversation (Roles: admin, physician)
     */
    async removeAssistantConversationRaw(requestParameters: RemoveAssistantConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeAssistantConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/conversations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    removeAssistantConversationRequestOptionsRaw(requestParameters: RemoveAssistantConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeAssistantConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/conversations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Removes saved conversation (Roles: admin, physician)
     */
    async removeAssistantConversation(requestParameters: RemoveAssistantConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeAssistantConversationRaw(requestParameters, initOverrides);
    }

    /**
     * Executes a saved prompt (Roles: admin, physician)
     */
    async runSavedPromptRaw(requestParameters: RunSavedPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringResource>> {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling runSavedPrompt.');
        }

        if (requestParameters.savedPromptRequest === null || requestParameters.savedPromptRequest === undefined) {
            throw new runtime.RequiredError('SavedPromptRequest','Required parameter requestParameters.savedPromptRequest was null or undefined when calling runSavedPrompt.');
        }

        const queryParameters: any = {};

        if (requestParameters.streamingKey !== undefined) {
            queryParameters['streamingKey'] = requestParameters.streamingKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/prompt/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SavedPromptRequestToJSON(requestParameters.savedPromptRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    runSavedPromptRequestOptionsRaw(requestParameters: RunSavedPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name','Required parameter requestParameters.name was null or undefined when calling runSavedPrompt.');
        }

        if (requestParameters.savedPromptRequest === null || requestParameters.savedPromptRequest === undefined) {
            throw new runtime.RequiredError('SavedPromptRequest','Required parameter requestParameters.savedPromptRequest was null or undefined when calling runSavedPrompt.');
        }

        const queryParameters: any = {};

        if (requestParameters.streamingKey !== undefined) {
            queryParameters['streamingKey'] = requestParameters.streamingKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/prompt/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: SavedPromptRequestToJSON(requestParameters.savedPromptRequest),
        };
        return responseConfig
    }

    /**
     * Executes a saved prompt (Roles: admin, physician)
     */
    async runSavedPrompt(requestParameters: RunSavedPromptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringResource> {
        const response = await this.runSavedPromptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Saves an assistant conversation (Roles: admin, physician)
     */
    async saveAssistantConversationRaw(requestParameters: SaveAssistantConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SavedAIConversation>> {
        if (requestParameters.savedAIConversation === null || requestParameters.savedAIConversation === undefined) {
            throw new runtime.RequiredError('SavedAIConversation','Required parameter requestParameters.savedAIConversation was null or undefined when calling saveAssistantConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/ai/conversations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SavedAIConversationToJSON(requestParameters.savedAIConversation),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SavedAIConversationFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    saveAssistantConversationRequestOptionsRaw(requestParameters: SaveAssistantConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.savedAIConversation === null || requestParameters.savedAIConversation === undefined) {
            throw new runtime.RequiredError('SavedAIConversation','Required parameter requestParameters.savedAIConversation was null or undefined when calling saveAssistantConversation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/ai/conversations`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: SavedAIConversationToJSON(requestParameters.savedAIConversation),
        };
        return responseConfig
    }

    /**
     * Saves an assistant conversation (Roles: admin, physician)
     */
    async saveAssistantConversation(requestParameters: SaveAssistantConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SavedAIConversation> {
        const response = await this.saveAssistantConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Converts Speech to Text (Roles: admin, physician)
     */
    async speechToTextRaw(requestParameters: SpeechToTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringResource>> {
        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling speechToText.');
        }

        const queryParameters: any = {};

        if (requestParameters.model !== undefined) {
            queryParameters['model'] = requestParameters.model;
        }

        if (requestParameters.prompt !== undefined) {
            queryParameters['prompt'] = requestParameters.prompt;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/ai/speech-to-text`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringResourceFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    speechToTextRequestOptionsRaw(requestParameters: SpeechToTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling speechToText.');
        }

        const queryParameters: any = {};

        if (requestParameters.model !== undefined) {
            queryParameters['model'] = requestParameters.model;
        }

        if (requestParameters.prompt !== undefined) {
            queryParameters['prompt'] = requestParameters.prompt;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }


        const responseConfig = {
            path: `/ai/speech-to-text`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
        return responseConfig
    }

    /**
     * Converts Speech to Text (Roles: admin, physician)
     */
    async speechToText(requestParameters: SpeechToTextRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringResource> {
        const response = await this.speechToTextRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const SpeechToTextModelEnum = {
    Whisper1: 'whisper-1'
} as const;
export type SpeechToTextModelEnum = typeof SpeechToTextModelEnum[keyof typeof SpeechToTextModelEnum];
